import { useModals } from "../../../context/ModalContext";
import { getSideBarOptions } from "../../common/SidebarToolkit/sidebar.config";

export const useFooter = () => {
    const { openModal } = useModals();

    const handlePrivacyPolicyClick = () => {
        openModal("Privacy-policy");
    };

    const handleTermsOfServiceClick = () => {
        openModal("Terms-Service-Modal");
    };

    const handleContactSupportClick = () => {
        openModal("Help-Modal");
    };


    return {
        handlePrivacyPolicyClick,
        handleTermsOfServiceClick,
        handleContactSupportClick,
    };
};